/**
 * @generated SignedSource<<9c1cb417abf97caae378303ff9e66a34>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MessageReactions_chat_messageFragment$data = {
  readonly id: string;
  readonly reactions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly deletedAt: ISO8601DateTimeString | null;
        readonly id: string;
        readonly senderId: string | null;
        readonly text: UnknownJSON;
      };
    }>;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ReactionButton_chat_messageFragment">;
  readonly " $fragmentType": "MessageReactions_chat_messageFragment";
};
export type MessageReactions_chat_messageFragment$key = {
  readonly " $data"?: MessageReactions_chat_messageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MessageReactions_chat_messageFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MessageReactions_chat_messageFragment",
  "selections": [
    (v0/*: any*/),
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ReactionButton_chat_messageFragment"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ReactionsConnection",
      "kind": "LinkedField",
      "name": "reactions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ReactionsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Message",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "text",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "senderId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "deletedAt",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Message",
  "abstractKey": null
};
})();

(node as any).hash = "abdf472ac82a9763656984d1369051f7";

export default node;
